(function() {
  'use strict';

  if (window.MrMapleZipClimate && window.MrMapleZipClimate.version) return;

  var STORAGE_KEYS = ['usdaZone', 'mrmaple_zone', 'mrmaple:customer:zone'];
  var HEAT_PROFILE_STORAGE_KEY = 'mrmaple_heat_profile';
  var HEAT_ZIP_STORAGE_KEY = 'mrmaple_heat_zip';
  var HEAT_ZIP_SOURCE_STORAGE_KEY = 'mrmaple_heat_zip_source';
  var PROFILE_ZIP_STORAGE_KEY = 'mrmaple_profile_zip';
  var PROFILE_ZIP_TS_STORAGE_KEY = 'mrmaple_profile_zip_ts';
  var ZIP_ZONE_LOOKUP_URL = 'https://cdn.shopify.com/s/files/1/1920/9319/files/filtered_csvjson.json';
  var PROFILE_ENDPOINT = '/apps/garden/v1/profile';
  var LOCATION_CONSENT_STYLE_ID = 'mrmaple-location-consent-styles';
  var LOCATION_CONSENT_ID = 'mrmaple-location-consent';
  var HUMID_HEAT_STATES = {
    AL: true,
    AR: true,
    FL: true,
    GA: true,
    HI: true,
    LA: true,
    MS: true,
    NC: true,
    PR: true,
    SC: true
  };
  var DRY_HEAT_STATES = {
    AZ: true,
    NV: true,
    NM: true,
    UT: true
  };
  var WESTERN_LOW_HUMIDITY_STATES = {
    CA: true,
    OR: true,
    WA: true
  };
  var zipZoneLookupPromise = null;
  var zipLocationCache = {};
  var profileZipLookupPromise = null;
  var profileZipSavePromise = null;
  var profileZipSaveKey = '';
  var locationConsentPromise = null;

  function normalizeZip(value) {
    var digits = String(value || '').replace(/\D/g, '');
    if (digits.length < 5) return '';
    return digits.slice(0, 5);
  }

  function normalizeZoneValue(value) {
    var shared = window.MrMapleZoneUtils;
    if (shared && typeof shared.parseStrictZoneInput === 'function') {
      var parsed = shared.parseStrictZoneInput(value);
      if (parsed && parsed.minIndex === parsed.maxIndex) return parsed.minLabel;
    }

    if (!value) return '';
    var source = String(value).trim().toLowerCase().replace(/^zones?\s*/i, '');
    var match = source.match(/^(\d{1,2})([ab])$/);
    if (!match) return '';
    return match[1] + match[2];
  }

  function getSavedZone() {
    var shared = window.MrMapleZoneUtils;
    if (shared && typeof shared.getSavedZone === 'function') {
      var sharedZone = shared.getSavedZone();
      if (sharedZone) return sharedZone;
    }

    for (var i = 0; i < STORAGE_KEYS.length; i += 1) {
      try {
        var zone = localStorage.getItem(STORAGE_KEYS[i]);
        if (zone) return zone;
      } catch (error) {}
    }

    return null;
  }

  function persistZone(value) {
    var normalized = normalizeZoneValue(value);
    if (!normalized) return null;

    for (var i = 0; i < STORAGE_KEYS.length; i += 1) {
      try { localStorage.setItem(STORAGE_KEYS[i], normalized); } catch (error) {}
    }

    try { localStorage.setItem('usdaZone_ts', String(Date.now())); } catch (error) {}

    window.dispatchEvent(new CustomEvent('garden:zone-updated', {
      detail: { zone: normalized }
    }));

    if (
      window.MrMapleProductZoneMap &&
      typeof window.MrMapleProductZoneMap.updateAll === 'function'
    ) {
      window.MrMapleProductZoneMap.updateAll();
    }

    return normalized;
  }

  function getSavedHeatZip() {
    try {
      return normalizeZip(localStorage.getItem(HEAT_ZIP_STORAGE_KEY));
    } catch (error) {}

    return '';
  }

  function getSavedHeatZipSource() {
    try {
      return String(localStorage.getItem(HEAT_ZIP_SOURCE_STORAGE_KEY) || '').trim().toLowerCase();
    } catch (error) {}

    return '';
  }

  function getSavedProfileZip() {
    try {
      return normalizeZip(localStorage.getItem(PROFILE_ZIP_STORAGE_KEY));
    } catch (error) {}

    return '';
  }

  function persistProfileZipLocally(zip) {
    var normalizedZip = normalizeZip(zip);
    if (!normalizedZip) return '';

    try {
      localStorage.setItem(PROFILE_ZIP_STORAGE_KEY, normalizedZip);
      localStorage.setItem(PROFILE_ZIP_TS_STORAGE_KEY, String(Date.now()));
    } catch (error) {}

    return normalizedZip;
  }

  function isCustomerLoggedIn() {
    if (window.MrMapleCustomer && window.MrMapleCustomer.isAuthenticated === false) {
      return false;
    }

    return Boolean(
      window.ShopifyCustomer && window.ShopifyCustomer.id ||
      window.MrMapleCustomer && (window.MrMapleCustomer.isAuthenticated || window.MrMapleCustomer.id) ||
      window.FirebaseAuthManager && typeof window.FirebaseAuthManager.isAuthenticated === 'function' && window.FirebaseAuthManager.isAuthenticated()
    );
  }

  function loadProfileZip() {
    var saved = getSavedProfileZip();
    if (saved) return Promise.resolve(saved);
    if (!isCustomerLoggedIn()) return Promise.resolve('');
    if (profileZipLookupPromise) return profileZipLookupPromise;

    profileZipLookupPromise = fetch(PROFILE_ENDPOINT + '?refresh=1', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function(response) {
        if (!response.ok) return '';
        return response.json();
      })
      .then(function(payload) {
        var profile = payload && payload.success && payload.profile ? payload.profile : null;
        if (!profile) return '';

        var profileZip = persistProfileZipLocally(profile.zipCode || profile.zip || profile.postalCode || '');
        if (profile.zone) {
          persistZone(profile.zone);
        }

        if (profileZip) {
          try { localStorage.setItem(HEAT_ZIP_STORAGE_KEY, profileZip); } catch (error) {}
        }

        return profileZip;
      })
      .catch(function() {
        return '';
      })
      .finally(function() {
        profileZipLookupPromise = null;
      });

    return profileZipLookupPromise;
  }

  function saveZipToProfile(zip, zone) {
    var normalizedZip = persistProfileZipLocally(zip);
    var normalizedZone = normalizeZoneValue(zone);
    if (!normalizedZip || !isCustomerLoggedIn()) return Promise.resolve(false);

    var saveKey = normalizedZip + ':' + (normalizedZone || '');
    if (profileZipSavePromise && profileZipSaveKey === saveKey) {
      return profileZipSavePromise.catch(function() { return false; });
    }

    var updates = { zipCode: normalizedZip };
    if (normalizedZone) updates.zone = normalizedZone;

    profileZipSaveKey = saveKey;
    var savePromise = fetch(PROFILE_ENDPOINT, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        action: 'update-profile',
        updates: updates
      })
    })
      .then(function(response) {
        if (!response.ok) return false;
        return response.json().then(function(payload) {
          if (!payload || payload.success === false) return false;
          var profile = payload.profile || {};
          if (profile.zipCode) persistProfileZipLocally(profile.zipCode);
          return true;
        }).catch(function() {
          return true;
        });
      })
      .catch(function() {
        return false;
      })
      .finally(function() {
        if (profileZipSavePromise === savePromise) {
          profileZipSavePromise = null;
          profileZipSaveKey = '';
        }
      });

    profileZipSavePromise = savePromise;
    return profileZipSavePromise;
  }

  function readShippingZipFromDocument() {
    var customerZip = document.querySelector('[data-customer-shipping-zip]');
    if (customerZip) {
      var fromCustomer = normalizeZip(customerZip.getAttribute('data-customer-shipping-zip'));
      if (fromCustomer) return fromCustomer;
    }

    var popover = document.getElementById('zone-popover');
    if (popover) {
      var fromPopover = normalizeZip(popover.getAttribute('data-zone-shipping-zip'));
      if (fromPopover) return fromPopover;
    }

    var mobileModal = document.querySelector('[data-zone-modal]');
    if (mobileModal) {
      var fromMobile = normalizeZip(mobileModal.getAttribute('data-zone-shipping-zip'));
      if (fromMobile) return fromMobile;
    }

    var modal = document.querySelector('[data-zone-map-modal]');
    if (modal) {
      var fromModal = normalizeZip(modal.getAttribute('data-zone-map-shipping-zip'));
      if (fromModal) return fromModal;
    }

    return '';
  }

  function getInitialZipPreference() {
    var savedZip = getSavedHeatZip();
    var savedSource = getSavedHeatZipSource();
    var profileZip = getSavedProfileZip();
    var shippingZip = readShippingZipFromDocument();

    if (savedZip && savedSource === 'manual') {
      return { zip: savedZip, source: 'manual' };
    }

    if (profileZip && savedSource !== 'shipping') {
      return { zip: profileZip, source: 'profile' };
    }

    if (shippingZip) {
      return { zip: shippingZip, source: 'shipping' };
    }

    if (savedZip) {
      return { zip: savedZip, source: savedSource || 'saved' };
    }

    var headerZip = document.getElementById('zipcode');
    if (headerZip) {
      var inputZip = normalizeZip(headerZip.value || headerZip.getAttribute('value'));
      if (inputZip) return { zip: inputZip, source: 'input' };
    }

    var careInput = document.querySelector('[data-care-zip-input]');
    if (careInput) {
      var careZip = normalizeZip(careInput.value);
      if (careZip) return { zip: careZip, source: 'input' };
    }

    return { zip: '', source: '' };
  }

  function getSuggestedZip() {
    return getInitialZipPreference().zip || '';
  }

  function getZipZoneLookupUrl() {
    var config = window.MrMapleCareGuideZoneConfig || window.MrMapleZipClimateConfig || {};
    return config.zoneLookupUrl || config.zipZoneLookupUrl || ZIP_ZONE_LOOKUP_URL;
  }

  function getZipZoneLookupData() {
    if (zipZoneLookupPromise) return zipZoneLookupPromise;

    zipZoneLookupPromise = fetch(getZipZoneLookupUrl(), { cache: 'force-cache' })
      .then(function(response) {
        if (!response.ok) throw new Error('Failed to load ZIP zone data');
        return response.json();
      })
      .then(function(data) {
        return Array.isArray(data) ? data : [];
      })
      .catch(function(error) {
        zipZoneLookupPromise = null;
        throw error;
      });

    return zipZoneLookupPromise;
  }

  function readEntryZip(entry) {
    if (!entry) return '';
    return normalizeZip(entry.zipcode || entry.zip_code || entry.zip || entry.ZIP || entry.Zip);
  }

  function readEntryZone(entry) {
    if (!entry) return '';
    return entry.zone || entry.Zone || entry.usdaZone || entry.usda_zone || entry.hardiness_zone || entry.hardinessZone || '';
  }

  function normalizeLookupZoneValue(value) {
    var exact = normalizeZoneValue(value);
    if (exact) return exact;

    var shared = window.MrMapleZoneUtils;
    if (shared && typeof shared.parseStrictZoneInput === 'function') {
      var parsed = shared.parseStrictZoneInput(value);
      if (parsed) return parsed.minLabel;
    }

    return '';
  }

  function lookupZoneFromZip(zip) {
    var normalizedZip = normalizeZip(zip);
    if (!normalizedZip) return Promise.resolve(null);

    return getZipZoneLookupData().then(function(rows) {
      for (var i = 0; i < rows.length; i += 1) {
        if (readEntryZip(rows[i]) !== normalizedZip) continue;

        var zone = normalizeLookupZoneValue(readEntryZone(rows[i]));
        if (zone) return zone;
      }

      return null;
    });
  }

  function lookupLocationFromZip(zip) {
    var normalizedZip = normalizeZip(zip);
    if (!normalizedZip) return Promise.resolve(null);
    if (zipLocationCache[normalizedZip]) return Promise.resolve(zipLocationCache[normalizedZip]);

    return fetch('https://api.zippopotam.us/us/' + encodeURIComponent(normalizedZip), { cache: 'force-cache' })
      .then(function(response) {
        if (!response.ok) throw new Error('Failed to lookup ZIP location');
        return response.json();
      })
      .then(function(data) {
        var place = data && data.places && data.places[0];
        if (!place) return null;

        var latitude = parseFloat(place.latitude);
        var longitude = parseFloat(place.longitude);
        var city = place['place name'] || '';
        var state = place['state abbreviation'] || '';
        var label = [city, state].filter(Boolean).join(', ') || ('ZIP ' + normalizedZip);
        var location = {
          zip: normalizedZip,
          city: city,
          state: String(state || '').toUpperCase(),
          latitude: isFinite(latitude) ? latitude : null,
          longitude: isFinite(longitude) ? longitude : null,
          label: label
        };

        zipLocationCache[normalizedZip] = location;
        return location;
      });
  }

  function parseUserRange(zone) {
    var shared = window.MrMapleZoneUtils;
    if (shared && typeof shared.parseStrictZoneInput === 'function') {
      return shared.parseStrictZoneInput(zone);
    }
    return null;
  }

  function classifyHeatLevel(location, userRange) {
    var state = location && location.state ? String(location.state).toUpperCase() : '';
    var zip = location && location.zip ? String(location.zip) : '';
    var zipPrefix = parseInt(zip.slice(0, 3), 10);

    if (state === 'TX') {
      if (!isNaN(zipPrefix) && zipPrefix >= 770 && zipPrefix <= 785) return 'humid-high';
      if (!isNaN(zipPrefix) && zipPrefix >= 786 && zipPrefix <= 799) return 'dry-heat';
    }

    if (state === 'CA') {
      if (!isNaN(zipPrefix) && zipPrefix >= 922 && zipPrefix <= 925) return 'dry-heat';
      return 'western-low-humidity';
    }

    if (HUMID_HEAT_STATES[state]) return 'humid-high';
    if (DRY_HEAT_STATES[state]) return 'dry-heat';
    if (WESTERN_LOW_HUMIDITY_STATES[state]) return 'western-low-humidity';

    if (userRange && userRange.min >= 10) return 'high-unknown';
    return 'moderate';
  }

  function buildHeatProfile(zip, location, userRange) {
    var normalizedZip = normalizeZip(zip);
    var normalizedLocation = location || { zip: normalizedZip, label: 'ZIP ' + normalizedZip, state: '' };
    var level = classifyHeatLevel(normalizedLocation, userRange);
      var profile = {
        zip: normalizedZip,
        label: normalizedLocation.label || ('ZIP ' + normalizedZip),
        state: normalizedLocation.state || '',
        city: normalizedLocation.city || '',
        latitude: typeof normalizedLocation.latitude === 'number' ? normalizedLocation.latitude : null,
        longitude: typeof normalizedLocation.longitude === 'number' ? normalizedLocation.longitude : null,
        level: level,
      headline: 'Moderate summer heat profile',
      summary: 'USDA zone measures winter low temperature. ZIP-level heat context helps refine summer placement, especially in Zones 10 and warmer.'
    };

    if (level === 'humid-high') {
      profile.headline = 'High humid heat-index profile';
      profile.summary = 'In humid Zone 10 climates such as (Florida), hot nights and high humidity make the heat load much higher than a lower-humidity Zone 10 (California), so use extra shade, airflow, cool roots, and careful cultivar selection.';
    } else if (level === 'western-low-humidity') {
      profile.headline = 'Lower-humidity western heat profile';
      profile.summary = 'USDA Zone 10 in much of California is not the same as humid Zone 10. A lower-humidity Zone 10, especially with marine influence or cooler nights, can support more listed plants when they get afternoon shade, cool roots, and steady irrigation.';
    } else if (level === 'dry-heat') {
      profile.headline = 'Dry high-heat profile';
      profile.summary = 'Lower humidity keeps the heat index below Gulf Coast conditions, but intense sun, hot soil, and reflected heat still make Zone 10+ risky. Use morning sun only, deep mulch, and consistent irrigation.';
    } else if (level === 'high-unknown') {
      profile.headline = 'Zone 10+ heat-index check needed';
      profile.summary = 'USDA Zone 10+ only tells us winter lows. ZIP-level heat context is needed because humid heat can make a cultivar non-viable even when a lower-humidity Zone 10 can support it.';
    }

    return profile;
  }

  function getSavedHeatProfile() {
    try {
      var raw = localStorage.getItem(HEAT_PROFILE_STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object' || !parsed.level) return null;
      return parsed;
    } catch (error) {}

    return null;
  }

  function persistHeatProfile(profile, options) {
    if (!profile || !profile.level) return null;
    var source = options && options.source ? String(options.source).trim().toLowerCase() : '';

    try {
      localStorage.setItem(HEAT_PROFILE_STORAGE_KEY, JSON.stringify(profile));
      if (profile.zip) localStorage.setItem(HEAT_ZIP_STORAGE_KEY, profile.zip);
      if (source) localStorage.setItem(HEAT_ZIP_SOURCE_STORAGE_KEY, source);
    } catch (error) {}

    window.dispatchEvent(new CustomEvent('mrmaple:heat-profile-updated', {
      detail: { heatProfile: profile }
    }));

    return profile;
  }

  function lookupZipClimate(zip, userRange, options) {
    var normalizedZip = normalizeZip(zip);
    if (!normalizedZip) return Promise.reject(new Error('Invalid ZIP code'));
    var source = options && options.source ? String(options.source).trim().toLowerCase() : 'manual';

    return Promise.all([
      lookupZoneFromZip(normalizedZip).catch(function() { return null; }),
      lookupLocationFromZip(normalizedZip).catch(function() { return null; })
    ]).then(function(results) {
      var zone = results[0];
      var location = results[1];
      var lookupRange = zone ? parseUserRange(zone) : userRange;
      var profile = buildHeatProfile(normalizedZip, location, lookupRange);

      if (zone) persistZone(zone);
      persistHeatProfile(profile, { source: source });
      persistProfileZipLocally(normalizedZip);

      return saveZipToProfile(normalizedZip, zone).then(function(profileSaved) {
        return {
          zip: normalizedZip,
          zone: zone,
          heatProfile: profile,
          profileSaved: profileSaved
        };
      });
    });
  }

  function ensureLocationConsentStyles() {
    if (document.getElementById(LOCATION_CONSENT_STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = LOCATION_CONSENT_STYLE_ID;
    style.textContent = [
      '#' + LOCATION_CONSENT_ID + '{position:fixed;inset:0;z-index:2147483647;display:grid;place-items:center;padding:18px;background:rgba(18,27,19,.32)}',
      '#' + LOCATION_CONSENT_ID + '[hidden]{display:none!important}',
      '#' + LOCATION_CONSENT_ID + ' .mrmaple-location-consent__dialog{width:min(360px,calc(100vw - 36px));padding:18px;border:1px solid rgba(56,118,29,.24);border-radius:16px;background:#fff;color:#1f2d1d;box-shadow:0 20px 42px rgba(20,32,21,.22);font-family:system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif}',
      '#' + LOCATION_CONSENT_ID + ' .mrmaple-location-consent__title{margin:0 0 8px;color:#2f6f1d;font-size:18px;font-weight:900;line-height:1.2}',
      '#' + LOCATION_CONSENT_ID + ' .mrmaple-location-consent__copy{margin:0;color:#42513f;font-size:14px;font-weight:650;line-height:1.45}',
      '#' + LOCATION_CONSENT_ID + ' .mrmaple-location-consent__actions{display:flex;gap:8px;justify-content:flex-end;margin-top:16px}',
      '#' + LOCATION_CONSENT_ID + ' button{min-height:38px;padding:8px 12px;border-radius:999px;font:inherit;font-size:13px;font-weight:850;cursor:pointer}',
      '#' + LOCATION_CONSENT_ID + ' [data-location-consent-cancel]{border:1px solid rgba(56,118,29,.24);background:#fff;color:#2f3c2d}',
      '#' + LOCATION_CONSENT_ID + ' [data-location-consent-allow]{border:1px solid #38761d;background:#38761d;color:#fff}'
    ].join('');
    document.head.appendChild(style);
  }

  function requestLocationConsent() {
    if (typeof document === 'undefined' || !document.body) {
      return Promise.resolve(false);
    }
    if (locationConsentPromise) return locationConsentPromise;

    ensureLocationConsentStyles();

    locationConsentPromise = new Promise(function(resolve) {
      var previousFocus = document.activeElement;
      var overlay = document.createElement('div');
      overlay.id = LOCATION_CONSENT_ID;
      overlay.setAttribute('role', 'presentation');
      overlay.innerHTML = [
        '<div class="mrmaple-location-consent__dialog" role="dialog" aria-modal="true" aria-labelledby="' + LOCATION_CONSENT_ID + '-title">',
        '<p class="mrmaple-location-consent__title" id="' + LOCATION_CONSENT_ID + '-title">Use your current location?</p>',
        '<p class="mrmaple-location-consent__copy">We only use location data to estimate your USDA growing zone and summer heat index. It is optional, and you can enter a ZIP code manually instead.</p>',
        '<div class="mrmaple-location-consent__actions">',
        '<button type="button" data-location-consent-cancel>Enter manually</button>',
        '<button type="button" data-location-consent-allow>Continue</button>',
        '</div>',
        '</div>'
      ].join('');

      function cleanup(value) {
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
        if (previousFocus && typeof previousFocus.focus === 'function') {
          try { previousFocus.focus({ preventScroll: true }); } catch (error) {}
        }
        locationConsentPromise = null;
        resolve(value);
      }

      overlay.addEventListener('click', function(event) {
        var target = event.target;
        if (!(target instanceof Element)) return;
        if (target.hasAttribute('data-location-consent-allow')) cleanup(true);
        if (target.hasAttribute('data-location-consent-cancel') || target === overlay) cleanup(false);
      });

      overlay.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          cleanup(false);
        }
      });

      document.body.appendChild(overlay);
      var allowButton = overlay.querySelector('[data-location-consent-allow]');
      if (allowButton && typeof allowButton.focus === 'function') {
        allowButton.focus({ preventScroll: true });
      }
    });

    return locationConsentPromise;
  }

  function getCurrentPositionWithConsent(options) {
    return requestLocationConsent(options).then(function(allowed) {
      if (!allowed) {
        var declined = new Error('Location permission not requested');
        declined.code = 'MRMAPLE_LOCATION_DECLINED';
        throw declined;
      }

      return new Promise(function(resolve, reject) {
        if (!navigator.geolocation) {
          reject(new Error('Geolocation unsupported'));
          return;
        }
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          enableHighAccuracy: false,
          timeout: options && options.timeout || 12000,
          maximumAge: options && options.maximumAge || 600000
        });
      });
    });
  }

  window.MrMapleZipClimate = {
    version: '1.0.0',
    STORAGE_KEYS: STORAGE_KEYS,
    HEAT_PROFILE_STORAGE_KEY: HEAT_PROFILE_STORAGE_KEY,
    HEAT_ZIP_STORAGE_KEY: HEAT_ZIP_STORAGE_KEY,
    HEAT_ZIP_SOURCE_STORAGE_KEY: HEAT_ZIP_SOURCE_STORAGE_KEY,
    PROFILE_ZIP_STORAGE_KEY: PROFILE_ZIP_STORAGE_KEY,
    normalizeZip: normalizeZip,
    getSavedZone: getSavedZone,
    persistZone: persistZone,
    getSavedHeatZip: getSavedHeatZip,
    getSavedHeatZipSource: getSavedHeatZipSource,
    getSavedProfileZip: getSavedProfileZip,
    getInitialZipPreference: getInitialZipPreference,
    getSuggestedZip: getSuggestedZip,
    readShippingZipFromDocument: readShippingZipFromDocument,
    getSavedHeatProfile: getSavedHeatProfile,
    persistHeatProfile: persistHeatProfile,
    loadProfileZip: loadProfileZip,
    saveZipToProfile: saveZipToProfile,
    lookupZipClimate: lookupZipClimate,
    lookupZoneFromZip: lookupZoneFromZip,
    lookupLocationFromZip: lookupLocationFromZip,
    requestLocationConsent: requestLocationConsent,
    getCurrentPositionWithConsent: getCurrentPositionWithConsent
  };
})();
